var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetwork2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 4.4H14.4V6.8H9.6V4.4ZM9 2C8.00624 2 7.2 2.80624 7.2 3.8V7.4C7.2 8.39376 8.00624 9.2 9 9.2H10.8V10.4H1.2C0.53625 10.4 0 10.9362 0 11.6C0 12.2638 0.53625 12.8 1.2 12.8H4.8V14H3C2.00624 14 1.2 14.8062 1.2 15.8V19.4C1.2 20.3938 2.00624 21.2 3 21.2H9C9.99376 21.2 10.8 20.3938 10.8 19.4V15.8C10.8 14.8062 9.99376 14 9 14H7.2V12.8H16.8V14H15C14.0062 14 13.2 14.8062 13.2 15.8V19.4C13.2 20.3938 14.0062 21.2 15 21.2H21C21.9938 21.2 22.8 20.3938 22.8 19.4V15.8C22.8 14.8062 21.9938 14 21 14H19.2V12.8H22.8C23.4638 12.8 24 12.2638 24 11.6C24 10.9362 23.4638 10.4 22.8 10.4H13.2V9.2H15C15.9938 9.2 16.8 8.39376 16.8 7.4V3.8C16.8 2.80624 15.9938 2 15 2H9ZM3.6 18.8V16.4H8.4V18.8H3.6ZM15.6 16.4H20.4V18.8H15.6V16.4Z",
    fill: "#1E3966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.0002 14C2.00644 14 1.2002 14.8062 1.2002 15.8V19.4C1.2002 20.3938 2.00644 21.2 3.0002 21.2H4.8002H7.2002H9.0002C9.99396 21.2 10.8002 20.3938 10.8002 19.4V15.8C10.8002 14.8062 9.99396 14 9.0002 14H3.0002ZM8.4002 16.4H3.6002V18.8H8.4002V16.4Z",
    fill: "#208C72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0002 14C14.0064 14 13.2002 14.8062 13.2002 15.8V19.4C13.2002 20.3938 14.0064 21.2 15.0002 21.2H16.8002H19.2002H21.0002C21.994 21.2 22.8002 20.3938 22.8002 19.4V15.8C22.8002 14.8062 21.994 14 21.0002 14H15.0002ZM20.4002 16.4H15.6002V18.8H20.4002V16.4Z",
    fill: "#EA1763"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork2);
export default __webpack_public_path__ + "static/media/network-2.ea92144f33cf7f4a5163c82b0a6a189b.svg";
export { ForwardRef as ReactComponent };